<script setup lang="ts">
withDefaults(defineProps<{ loading?: boolean }>(), { loading: false });

const store = useAirportsFilterStore();
const resultsStore = useSearchResultIndexStore();
const locationLabels = useLocationLabels();
</script>

<template>
  <UiCustomFilterCheckboxGroupSkeleton v-if="loading" />

  <template v-else>
    <ResultsFiltersAirportGroup
      :section-label="locationLabels.city(store.departureSectionLabel)"
      :airports="resultsStore.filteredDepartureAirports"
      :selected-airports="store.selectedDeparture"
      :all-selected="store.allDepartureSelected"
      @toggle-all="store.toggleAll('departure')"
      @toggle-airport="(id, val) => store.toggleAirport('departure', id, val)"
      @solo="(id) => store.solo('departure', id)"
    />
    <UiCustomSeparatorLine />
    <ResultsFiltersAirportGroup
      :section-label="locationLabels.city(store.arrivalSectionLabel)"
      :airports="resultsStore.filteredArrivalAirports"
      :selected-airports="store.selectedArrival"
      :all-selected="store.allArrivalSelected"
      @toggle-all="store.toggleAll('arrival')"
      @toggle-airport="(id, val) => store.toggleAirport('arrival', id, val)"
      @solo="(id) => store.solo('arrival', id)"
    />
  </template>
</template>
